import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import { useTheme } from '../../../contexts/ThemeContext';

const DateInput = ({
  value,
  onChange,
  placeholder,
  format = 'DD/MM/YYYY',
  style,
  className,
  ...props
}) => {
  const { theme } = useTheme();

  return (
    <DatePicker
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      format={format}
      style={{
        backgroundColor: theme.background,
        color: theme.textSecondary,
        borderColor: theme.border,
        width: '100%',
        ...style
      }}
      className={className}
      {...props}
    />
  );
};

DateInput.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  format: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default DateInput; 